export default __webpack_public_path__ + "static/media/appliances_cat.9f5e6c96.jpg";